import Util from "./Util.js";
//
import { gsap } from "./Util.js";
import { CustomEase } from "./Util.js";

class Menu extends Util {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.setVars();
    this.events();
  }

  setVars() {
    this.btn = document.querySelector(".btn-menu");
    this.menu = document.querySelector(".menu");
  }

  events() {
    this.btn.addEventListener("click", () => {
      if (document.documentElement.classList.contains("is-menu-open")) {
        document.documentElement.classList.remove("is-menu-open");
        window.SCROLL_INSTANCE.lenis.start();
      } else {
        document.documentElement.classList.add("is-menu-open");
        window.SCROLL_INSTANCE.lenis.stop();
      }
    });
  }
}

export default Menu;
